/*
 * Copyright (C) 2015 - 2018 Kosmos contact@kosmos.fr
 *
 * Projet: supervision-webapp-contrib
 * Version: 7.1.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
(function($) {
    'use strict';

    /**
     * Déclaration d'un tri spécifique pour les pourcentages nnn % / -
     */
    $.extend($.fn.dataTableExt.oSort, {
        'percent-pre': function (a) {
            var b = Number.NaN;
            if (a !== null) {
                b = parseInt(a, 10);
            }
            return b;
        },

        'percent-asc': function (x, y) {
            var result = 0;
            if (isNaN(x) && isNaN(y)) {
                result = 0;
            } else if (x < y || isNaN(y)) {
                result = -1;
            } else if (x > y || isNaN(x)) {
                result = 1;
            }
            return result;
        },

        'percent-desc': function (x, y) {
            var result = 0;
            if (isNaN(x) && isNaN(y)) {
                result = 0;
            } else if (x < y || isNaN(x)) {
                result = 1;
            } else if (x > y || isNaN(y)) {
                result = -1;
            }
            return result;
        }
    });


    var dataTableCaches = $('.dataTableCaches');
    dataTableCaches.dataTable({
        'aaSorting': [[3, 'desc']],
        'aoColumns': [
            null,
            null,
            null,
            {'sType': 'percent'},
            null,
            null,
            {'sType': 'percent'},
            null,
            {'bSortable': false, 'bSearchable': false}
        ]
    });
})(jQuery.noConflict());

